<template>
	<v-dialog  
	 	v-model="dialog"
		:fullscreen="fullscreen"
		transition="dialog-bottom-transition"
		scrollable
		persistent
		:max-width="maxWidth"
	>
		<template v-slot:activator="{ on: dialog, attrs }">
			<slot name="activator" :attrs="attrs" :dialog="dialog">
				<v-btn icon v-bind="attrs" v-on="{ ...dialog }">
					<v-icon>mdi-pencil</v-icon>
				</v-btn>
			</slot>
		</template>

		<v-card>
			<v-toolbar flat dark color="primary" style="flex: 0 1 auto;">
				<v-avatar>
					<v-icon>{{ icon }}</v-icon>
				</v-avatar>
				<v-toolbar-title>{{ title }}</v-toolbar-title>
				
				<v-spacer></v-spacer>

				<v-btn icon @click="fullscreen = !fullscreen">
					<v-icon v-if="fullscreen">mdi-arrow-collapse</v-icon>
					<v-icon v-else="fullscreen">mdi-arrow-expand</v-icon>
				</v-btn>
				<v-btn icon @click="dialog=false" >
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>

			<v-card-text>
				<v-container>
					<v-form ref="form">
						<v-expansion-panels v-model="panel" multiple>
							<v-expansion-panel>
								<!-- <v-expansion-panel-header>Основна інформація</v-expansion-panel-header> -->
								<v-expansion-panel-header>
									<v-toolbar flat>
										<!-- <v-app-bar-nav-icon>
											<v-icon>mdi-car</v-icon>
										</v-app-bar-nav-icon> -->
										<v-toolbar-title>Основна інформація</v-toolbar-title>
										<!-- <v-toolbar-title v-if="id">{{ `№ ${id}`}}</v-toolbar-title>
										<v-toolbar-title v-else>Основна інформація</v-toolbar-title> -->
										<v-spacer></v-spacer>
									</v-toolbar>
								</v-expansion-panel-header>
								<v-expansion-panel-content>
									<v-row>
										<v-col cols="12" md="8">
											<v-text-field
												:label="$vuetify.lang.t('$vuetify.name') | capitalize"
												v-model="item.name"
												clearable
												outlined
												dense
												hide-details="auto"
												:rules="[rules.required]"
											></v-text-field>
										</v-col>
										<v-col cols="12" md="4">
											<v-text-field
												:label="$vuetify.lang.t('$vuetify.code') | capitalize"
												v-model="item.code"
												clearable
												outlined
												dense
												hide-details="auto"
											></v-text-field>
										</v-col>
										<v-col cols="12" md="3">
											<v-text-field
												label="Ціна"
												v-model="item.price"
												clearable
												outlined
												dense
												hide-details="auto"
												:rules="[rules.required]"
											>
												<template v-slot:append-outer>
													<v-checkbox
														v-model="item.is_vat"
														label="З ПДВ"
														dense
														hide-details="auto"
													></v-checkbox>
												</template>
											</v-text-field>
										</v-col>
										<v-col cols="12" md="3">
											<v-text-field
												label="Ставка ПДВ"
												v-model="item.vat"
												clearable
												outlined
												dense
												hide-details="auto"
											></v-text-field>
										</v-col>
										<v-col cols="12" md="3">
											<v-text-field
												label="Кількість одиниць"
												v-model="item.quantity"
												clearable
												outlined
												dense
												hide-details="auto"
											></v-text-field>
										</v-col>
										<v-col cols="12">
											<v-textarea
												v-model="item.description"
												:label="$vuetify.lang.t('$vuetify.comment') | capitalize"
												hint=""
												rows="2"
												outlined
												dense
												hide-details="auto"
											></v-textarea>
										</v-col>
										<v-col cols="12" md="3">
											<v-text-field
												label="Ідентифікатор зовнішньої системи"
												v-model="item.idExternal"
												clearable
												outlined
												dense
												hide-details="auto"
											></v-text-field>
										</v-col>
									</v-row>
								</v-expansion-panel-content>
							</v-expansion-panel>
							<v-expansion-panel v-if="category_code=='DRUG'">
								<v-expansion-panel-header>Додаткова інформація
									<!-- <v-toolbar flat>
										<v-toolbar-title>Продукти / Послуги</v-toolbar-title>
										<v-spacer></v-spacer>
										<v-btn outlined class="mx-3" @click="onProductsClear()" >
											<v-icon>mdi-broom</v-icon>
											Очистити
										</v-btn>
										
										<v-divider vertical></v-divider>
										
										<v-btn outlined  class="mx-1" v-if="products.length" @click="onExport">
											<v-icon left>mdi-export</v-icon>
											Експорт
										</v-btn>

										<z-import-excel 
											:headers="headers"
											:fields="fields"
											@ok="addProducts"
										>
											<template v-slot:activator="props">
												<v-btn outlined class="mx-3" v-bind="props.attrs" v-on="{ ...props.dialog, ...props.tooltip}">
													<v-icon left>mdi-import</v-icon>
													Імпорт
												</v-btn>
											</template>
										</z-import-excel>

										<v-divider vertical inset></v-divider>

										<z-detail-product @add="addProduct">
											<template v-slot:activator="props">
												<v-btn outlined v-bind="props.attrs" v-on="{ ...props.dialog, ...props.tooltip}">
													<v-icon left>mdi-plus</v-icon>
													Додати
												</v-btn>
											</template>
										</z-detail-product>
									</v-toolbar> -->
								</v-expansion-panel-header>
								<v-expansion-panel-content>
									<!-- Лікарські засоби -->
									 <v-row>
										<v-col cols="12" md="3">
											<v-text-field
												label="Код Моріон"
												v-model="item.idMorion"
												clearable
												outlined
												dense
												type="number"
												hide-details="auto"
												append-outer-icon="mdi-arrow-right-box"
												@keyup.ctrl.90="$set(item,'idMorion',93724)"
												@click:append-outer="searchDrugByMorion"
											>
												<!-- <template v-slot:append-outer>
													<v-tooltip bottom>
														<template v-slot:activator="{ on, attrs }">
															<v-btn icon v-bind="attrs" v-on="on" @click="searchDrugByMorion">
																<v-icon>mdi-arrow-right-box</v-icon>
															</v-btn>
														</template>
														<span>Ідентифікація ЛС за кодом Моріон</span>
													</v-tooltip>
												</template> -->
											</v-text-field>
										</v-col>
										<v-col cols="12" md="8">
											<v-autocomplete
												v-model="item.drug"
												:items="drugs"
												:loading="loadings.drugs"
												:search-input.sync="search_drug"
												outlined
												dense
												clearable
												hide-details
												hide-selected
												item-text="name"
												item-value="id"
												return-object
												label="Лікарський засіб"
											>
												<template v-slot:no-data>
													<v-list-item>
													<v-list-item-title>
														Введіть назву
														<strong>Лікарського засобу</strong>
													</v-list-item-title>
													</v-list-item>
												</template>
												<template v-slot:selection="data">
													<span>{{ data.item.name }}, {{ data.item.form }}</span>
												</template>
												<template v-slot:item="{ item }">
													<v-list-item-content>
														<v-list-item-title>{{ item.name }}, {{ item.form }}</v-list-item-title>
														<!-- <v-list-item-subtitle v-text="item?.maker?.name ? item.maker.name : ''"></v-list-item-subtitle> -->
														<!-- <v-list-item-subtitle>{{ item?.maker?.name ? item.maker.name : '' }}</v-list-item-subtitle> -->
													</v-list-item-content>
												</template>
											</v-autocomplete>
										</v-col>
									 </v-row>
								</v-expansion-panel-content>
							</v-expansion-panel>

							<v-expansion-panel v-if="category_code=='VEHICLE'">
								<v-expansion-panel-header>Додаткова інформація</v-expansion-panel-header>
								<v-expansion-panel-content>
									<!-- Транспортні засоби -->
									 <v-row>
										<v-col cols="12" md="4">
											<v-combobox
												v-model="item.category"
												:items="categories"
												label="Категорія"
												outlined
												dense
												item-text="name"
												item-value="id"
												hide-details="auto"
												:loading="loading.categories"
												:rules="[rules.onlyFromList]"
												@change="onCategory"
												@focus="loadCategories"
											></v-combobox>
										</v-col>
										<v-col cols="12" md="4">
											<v-combobox
												v-model="item.brand"
												:items="brands"
												label="Марка"
												outlined
												dense
												item-text="name"
												item-value="id"
												hide-details="auto"
												:loading="loading.brands"
												:rules="[rules.onlyFromList]"
												@change="onBrand"
												@focus="loadBrands"
											></v-combobox>
										</v-col>
										<v-col cols="12" md="4">
											<v-combobox
												v-model="item.model"
												:items="models"
												label="Модель"
												outlined
												dense
												item-text="name"
												item-value="id"
												hide-details="auto"
												:loading="loading.models"
												:rules="[rules.onlyFromList]"
												@change="onModel"
												@focus="loadModels"
											></v-combobox>
										</v-col>
										<v-col cols="12" md="4">
											<v-combobox
												v-model="item.generation"
												:items="generations"
												label="Покоління"
												outlined
												dense
												item-text="name"
												item-value="id"
												hide-details="auto"
												:loading="loading.generations"
												@change="onGeneration"
												@focus="loadGenerations"
											>
												<template v-slot:item="{ on, item }">
													<v-list-item v-on="on">
														<v-list-item-content>
															<v-list-item-title>{{ item.name }}</v-list-item-title>
															<v-list-item-subtitle>{{ item.yearFrom }} - {{ item.yearTo }}</v-list-item-subtitle>
														</v-list-item-content>
													</v-list-item>
												</template>
											</v-combobox>
										</v-col>
										<v-col cols="12" md="4">
											<v-combobox
												v-model="item.modification"
												:items="modifications"
												label="Модифікація"
												outlined
												dense
												item-text="name"
												item-value="id"
												hide-details="auto"
												:loading="loading.modifications"
												@focus="loadModifications"
											></v-combobox>
										</v-col>
										<v-col cols="12" md="4">
											<v-combobox
												v-model="item.yearProd"
												:items="years"
												label="Рік випуску"
												outlined
												dense
												hide-details="auto"
												:loading="loading.yearProd"
												
												@focus="loadYearProds"
											></v-combobox>
											<!-- :rules="[rules.required]" -->
										</v-col>
										<v-col cols="12" md="4">
											<v-combobox
												v-model="item.driver"
												:items="drivers"
												label="Тип приводу"
												outlined
												dense
												item-text="name"
												item-value="id"
												hide-details="auto"
												:loading="loading.drivers"
												@focus="loadDrivers"
											></v-combobox>
										</v-col>
										<v-col cols="12" md="4">
											<v-text-field
												v-model="item.engineVolume"
												label="Об'єм двигуна, л."
												outlined
												dense
												type="number"
												hide-details="auto"
												:min="0"
												:max="10"
											></v-text-field>
										</v-col>
										<v-col cols="12" md="4">
											<v-combobox
												v-model="item.fuel"
												:items="fuels"
												label="Тип палива"
												outlined
												dense
												item-text="name"
												item-value="id"
												hide-details="auto"
												:loading="loading.fuels"
												@focus="loadFuels"
											></v-combobox>
										</v-col>
										<v-col cols="12" md="4">
											<v-combobox
												v-model="item.gearbox"
												:items="gearboxes"
												label="Коробка передач"
												outlined
												dense
												item-text="name"
												item-value="id"
												hide-details="auto"
												:loading="loading.gearboxes"
												@focus="loadGearboxes"
											></v-combobox>
										</v-col>
										<v-col cols="12" md="4">
											<v-combobox
												v-model="item.color"
												:items="colors"
												label="Колір"
												outlined
												dense
												item-text="name"
												item-value="id"
												hide-details="auto"
												:loading="loading.colors"
												@focus="loadColors"
											></v-combobox>
										</v-col>
									 </v-row>
								</v-expansion-panel-content>
							</v-expansion-panel>
						</v-expansion-panels>
					</v-form>
				</v-container>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text @click.native="onCancel">{{ $vuetify.lang.t('$vuetify.cancel') }}</v-btn>
				<v-btn color="success" dark @click.native="onOK" :disabled="loading">{{ $vuetify.lang.t('$vuetify.ok') }}</v-btn>
			</v-card-actions>
		</v-card>

		<v-snackbar v-model="snackbar.visible" :timeout="snackbar.timeout" :color="snackbar.color">
			{{ snackbar.text }}
			<template v-slot:actions>
				<v-btn icon="mdi-window-close" @click="snackbar.visible = false"></v-btn>
			</template>
		</v-snackbar>

		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>
	</v-dialog>
</template>

<script>
import axios from 'axios'
import mixin from './mixin/main'

export default {
	name: 'DialogDetailPricelist',
	mixins: [mixin],
	components: {},
	data: () => ({
		panel: [0, 1],

		item: {
			quantity: 1,
			drug: null,
		},

		//selected_products: [],

		search_drug: null,

		//itemPdf: {},

		snackbar: {
			visible: false,
			text: null,
			timeout: 2000,
			color: "success"
		},

		loadings: {
			drugs: false,

			categories: false,
			brands: false,
			models: false,
			generations: false,
			modifications: false,
			yearProd: false,
			drivers: false,
			fuels: false,
			gearboxes: false,
			colors: false,
		},

		drugs: [],
		categories: [],
		brands: [],
		models: [],
		generations: [],
		modifications: [],
		bodystyles: [],
		drivers: [],
		gearboxes: [],
		
		/* types: [],
		categories: [],
		directions: [],
		sources: [],
		currencies: [],
		sellers: [], */
	}),

	props: {
		title: 				{ type: String, default: 'Продукт / Послуга' },
		icon: 				{ type: String, default: 'mdi-package-variant' },
		maxWidth: 			{ type: Number, default: 800 },
		category: 			{ type: Object, default: null },
	},

	watch: {
		search_drug (val) {
			if (val) {
				if (val.length > 3) {
					setTimeout(() => (this.searchDrugs(val)), 2000)
				}
			}
			//if (val.length < 4) return

			//this.searchDrugs(val)
		}
    },

	computed: {
		category_code() {
			//console.log(this.$options.name, 'category_code', 'category', this.category)
			return this.category?.code ? this.category.code : null
		},
		

		/* readonly_category() {
			return this.item?.id ? true : false
		}, */

		id() {
			return this.item?.id ? this.item.id : null
		},
	},

	created () {
		//console.log(this.$options.name, 'created')

		this.fullscreen = true;
	},

	methods: {
		searchDrugs(search) {
			let params = { search: search }

			var that = this
			this.loadings.drugs = true
			return axios.get('/drug', { params: params} ).then(response => {
				//console.log(that.$options.name, 'searchDrugs','response.data', response.data)
				that.drugs = response.data
			}, error => { console.log('error', error)}
			).finally(() => (this.loadings.drugs = false));
		},

		searchDrugByMorion() {
			//console.log(this.$options.name, 'searchDrugByMorion','this.item', this.item)

			if(this.item.idMorion) {
				let params = { idMorion: this.item.idMorion }

				var that = this
				this.loadings.drugs = true
				return axios.get('/drug', { params: params} ).then(response => {
					//console.log(that.$options.name, 'searchDrugs','response.data', response.data)
					if(response.data.length) {
						that.drugs = response.data
						that.item.drug = that.drugs[0]
					}
				}, error => { console.log('error', error)}
				).finally(() => (this.loadings.drugs = false));
			}
		},

		

		/* find(id) {
			var that = this
			this.loading = true
			return axios.get(`/pricelist/product/${id}`).then(response => {
				//console.log(that.$options.name, 'find','response.data', response.data)
				that.item = response.data
			}, error => { console.log('error', error)}).finally(() => (this.loading = false));
		},

		create() {
			var that = this
			this.loading = true
			return axios.post(`/pricelist/product`, this.item).then(response => {
				//console.log('index', 'create','response.data', response.data)
				that.item = response.data
			}, error => { console.log(error)}).finally(() => (this.loading = false));
		},

		update(id) {
			var that = this
			this.loading = true
			return axios.put(`/pricelist/product/${id}`, this.item).then(response => {
				//console.log('index', 'update','response.data', response.data)
				that.item = response.data
			}, error => { console.log(error)}).finally(() => (this.loading = false));
		},

		save() {
			//return this.id ? this.update(this.selected) : this.create();
			return this.item?.id ? this.update(this.item.id) : this.create();
		}, */

		onOpen () {
			//console.log(this.$options.name, 'onOpen', 'selected', this.selected)
			if(this.selected) {
				this.item = {...this.selected}
			}
		},

		onOK() {
			//console.log(this.$options.name, 'onOK', 'item', this.item)

			if(this.$refs.form.validate()) {
				this.$emit('ok', this.item);

				/* this.loading = true
				this.save().then(() => { 
					this.$emit('ok', this.item);
					this.dialog = false
				}).finally(() => { this.loading = false }) */
			}
		},
	},
}
</script>